import { render, staticRenderFns } from "./CRMAttributeConfig.vue?vue&type=template&id=6f12cee6&scoped=true&"
import script from "./CRMAttributeConfig.vue?vue&type=script&lang=js&"
export * from "./CRMAttributeConfig.vue?vue&type=script&lang=js&"
import style0 from "./CRMAttributeConfig.vue?vue&type=style&index=0&id=6f12cee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f12cee6",
  null
  
)

export default component.exports